export const AppThemeKeys: Record<string, string> = {
  BIKE: 'BikeThemeLight light-theme',
  BIKE_DARK: 'BikeThemeDark'
}
